module.exports = __webpack_public_path__ + "2930c22adf0d5503a5627460183cba87.fbx";